module.exports = __webpack_public_path__ + "img/hr-H-B-6-unload-connect-shadow.ae55b9c7.png";